import React, { createContext } from 'react';

const UploaderContext = createContext(null);

export const getComponentConsumer = (Component) => (props) => (
  <UploaderContext.Consumer>{(uploader) => <Component {...props} uploader={uploader} />}</UploaderContext.Consumer>
);

export default UploaderContext;
